import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n";
import 'react-data-grid/lib/styles.css';
import './index.css';
import {ModalProvider} from "./contexts/ModalContext";
import {NotificationProvider} from "./contexts/NotificationContext";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <NotificationProvider>
            <ModalProvider>
                <App/>
            </ModalProvider>
        </NotificationProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
